/* tslint:disable */
/* eslint-disable */
/**
 * Ordering Api
 * Its4 Plan Ordering Api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DoneTotals,
  WeeklyThroughput,
} from '../models/index';
import {
    DoneTotalsFromJSON,
    DoneTotalsToJSON,
    WeeklyThroughputFromJSON,
    WeeklyThroughputToJSON,
} from '../models/index';

export interface GetDoneTotalsRequest {
    start: Date;
    end: Date;
    projectId: number;
}

export interface GetWeeklyThroughputRequest {
    start: Date;
    end: Date;
}

/**
 * 
 */
export class OrderedProjectHistoryApi extends runtime.BaseAPI {

    /**
     */
    async getDoneTotalsRaw(requestParameters: GetDoneTotalsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DoneTotals>> {
        if (requestParameters['start'] == null) {
            throw new runtime.RequiredError(
                'start',
                'Required parameter "start" was null or undefined when calling getDoneTotals().'
            );
        }

        if (requestParameters['end'] == null) {
            throw new runtime.RequiredError(
                'end',
                'Required parameter "end" was null or undefined when calling getDoneTotals().'
            );
        }

        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getDoneTotals().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['start'] != null) {
            queryParameters['start'] = (requestParameters['start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['end'] != null) {
            queryParameters['end'] = (requestParameters['end'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/orderedprojects/history/done-totals`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DoneTotalsFromJSON(jsonValue));
    }

    /**
     */
    async getDoneTotals(requestParameters: GetDoneTotalsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DoneTotals> {
        const response = await this.getDoneTotalsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getWeeklyThroughputRaw(requestParameters: GetWeeklyThroughputRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WeeklyThroughput>>> {
        if (requestParameters['start'] == null) {
            throw new runtime.RequiredError(
                'start',
                'Required parameter "start" was null or undefined when calling getWeeklyThroughput().'
            );
        }

        if (requestParameters['end'] == null) {
            throw new runtime.RequiredError(
                'end',
                'Required parameter "end" was null or undefined when calling getWeeklyThroughput().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['start'] != null) {
            queryParameters['start'] = (requestParameters['start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['end'] != null) {
            queryParameters['end'] = (requestParameters['end'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/orderedprojects/history/weekly-throughput`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WeeklyThroughputFromJSON));
    }

    /**
     */
    async getWeeklyThroughput(requestParameters: GetWeeklyThroughputRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WeeklyThroughput>> {
        const response = await this.getWeeklyThroughputRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
